var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg14B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(1 0 0 1 0 -987.362121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3336"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.66,
    fill: "none",
    stroke: "#000000",
    d: "M0.7 1019.74 C0.7 1002.35 14.96 988.23 32.51 988.23 C50.05 988.23 64.31 1002.35 64.31 1019.74 C64.31 1037.12 50.05 1051.25 32.51 1051.25 C14.96 1051.25 0.7 1037.12 0.7 1019.74 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3338"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.17,
    fill: "#ffffff",
    fillRule: "evenodd",
    stroke: "#000000",
    d: "M15.44 1018.83 C15.44 1010.07 22.93 1002.95 32.15 1002.95 C41.38 1002.95 48.87 1010.07 48.87 1018.83 C48.87 1027.6 41.38 1034.72 32.15 1034.72 C22.93 1034.72 15.44 1027.6 15.44 1018.83 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tspan3344",
    transform: "matrix(1.013137 0 0 0.987034 15.574509 1005.854675)"
  }, /*#__PURE__*/React.createElement("text", {
    kerning: 0,
    fontFamily: ".AppleSystemUIFont",
    fontWeight: 700,
    fontSize: 22.19
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21.45
  }, "14"))), /*#__PURE__*/React.createElement("g", {
    id: "a4153",
    transform: "matrix(0.660883 0 0 0.657202 -0.849268 987.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3349"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.01,
    fill: "#0000ff",
    stroke: "#000000",
    d: "M15.88 16.46 L85.3 16.46"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "path3351"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.66,
    fill: "none",
    stroke: "#000000",
    d: "M7.96 1039.71 L57.21 1039.45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path4158"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#008000",
    d: "M6.97 1038.27 C3.95 1034.2 1.93 1029.31 1.15 1024.2 C0.82 1022.06 0.82 1017.33 1.14 1015.28 C2.14 1009.03 4.66 1003.64 8.75 999.01 L9.49 998.17 L32.58 998.24 L55.67 998.3 L56.71 999.52 C59.48 1002.78 61.76 1007 62.97 1011.16 C64.84 1017.58 64.48 1024.94 62 1031.18 C61.1 1033.44 59.37 1036.53 58.02 1038.28 L57.41 1039.08 L39.78 1039.15 C30.09 1039.18 18.92 1039.25 14.97 1039.29 L7.77 1039.36 L6.97 1038.27 Z M34.79 1034.65 C36.65 1034.37 38.19 1033.88 39.91 1033.03 C41.74 1032.13 42.89 1031.31 44.33 1029.88 C47.37 1026.86 48.96 1023.08 48.96 1018.85 C48.97 1014.7 47.5 1011.07 44.61 1008.08 C40.99 1004.32 36.04 1002.47 30.71 1002.89 C29.16 1003.01 27.06 1003.48 25.72 1004.01 C21.21 1005.78 17.57 1009.56 16.08 1014.02 C15.05 1017.08 15.11 1020.97 16.22 1024.04 C17.77 1028.35 21.29 1031.9 25.75 1033.66 C26.8 1034.07 28.5 1034.52 29.68 1034.69 C30.92 1034.87 33.46 1034.85 34.79 1034.65 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3435",
    transform: "matrix(1 0 0 1 0 987.362121)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.91 9.85 C11.25 9.31 15.09 6.51 17.02 5.41 C19.57 3.95 22.11 2.95 25.4 2.12 C27.64 1.56 28.3 1.5 32.35 1.5 C35.86 1.49 37.26 1.58 38.83 1.93 C44.1 3.08 49.65 5.83 53.08 8.98 L54.26 10.07 L32.51 10.08 C18.31 10.08 10.82 10 10.91 9.85 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3437",
    transform: "matrix(1 0 0 1 0 987.362121)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M29.88 63.29 C22.65 62.71 16.09 59.76 10.84 54.7 L8.8 52.74 L22.24 52.73 C29.64 52.72 40.34 52.65 46.02 52.56 L56.34 52.41 L55.72 53.23 C54.88 54.33 51.64 57.07 49.7 58.33 C43.92 62.09 36.88 63.85 29.88 63.29 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14B);
export default __webpack_public_path__ + "static/media/14B.c0be400f2fd7ba90ecd6036dce688dba.svg";
export { ForwardRef as ReactComponent };